module.exports = __webpack_public_path__ + "img/nodata.b4adc6a5.svg";